<template>
  <div
    class="bonus-campaign-hero"
    :class="{ 'bonus-campaign-hero--grid-cell': stretchToGrid }"
  >
    <img
      class="bonus-campaign-hero__img"
      :src="heroSrc"
      alt=""
    />
    <div class="bonus-campaign-hero__shade" aria-hidden="true" />
    <h2 class="bonus-campaign-hero__title">{{ headline }}</h2>
  </div>
</template>

<script setup>
import { computed, defineProps } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps({
  heroSrc: { type: String, required: true },
  headlineKey: { type: String, required: true },
  stretchToGrid: { type: Boolean, default: false },
});

const { t } = useI18n();

const headline = computed(() => t(props.headlineKey));
</script>

<style scoped lang="scss">
@import "@/styles/portal-home/bonus-campaign-hero-banner";
</style>
